module.exports = __webpack_public_path__ + "media/Windfish.6a76df76.mp4";